<template>
  <v-card :color="baseColor" class="white--text">
    <v-card-text>
      <v-layout>
        <v-flex xs2 text-left>
          <slot name="stat_img"></slot>
        </v-flex>
        <v-flex xs10 text-right>
          <div class="text-right">
            <slot name="stat_data"></slot>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
  </v-card>
</template>

<script>
export default {
  name: 'SimulateStat',
  props: {
    title: String,
    baseColor: {
      type: String,
      default: '#95c67e'
    }
  }
}
</script>

<style lang="scss" scoped>
.text-grey {
  color: #666666 !important;
}
.text-black {
  color: #222222 !important;
}
</style>
